import { render } from "./Skill.vue?vue&type=template&id=e1d271ae&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=ts"
export * from "./Skill.vue?vue&type=script&lang=ts"

import "./Skill.vue?vue&type=style&index=0&id=e1d271ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1d271ae"

export default script